import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RomeLibraryModule } from '../lib/rome-library.module';
import { RomeKendoModule } from '../rome-kendo/rome-kendo.module';
import { FormKfiProductSelectionComponent } from './kfi/components/form-inputs/form-kfi-product-selection.component';
import { KfiAboutTheMortgageControlComponent } from './kfi/components/kfi-about-the-mortgage-control/kfi-about-the-mortgage-control.component';
import { KfiApplicantControlComponent } from './kfi/components/kfi-applicant-control/kfi-applicant-control.component';
import { KfiProgressStepperComponent } from './kfi/components/kfi-progress-stepper/kfi-progress-stepper.component';
import { KfiSectionNavigationComponent } from './kfi/components/kfi-section-navigation/kfi-section-navigation.component';
import { SaveKfiComponent } from './kfi/components/save-kfi/save-kfi.component';
import { DeleteKfiApplicantDialogComponent } from './kfi/dialogs/delete-kfi-applicant-dialog/delete-kfi-applicant-dialog.component';
import { KfiApplicantPage } from './kfi/pages/kfi-applicant/kfi-applicant.page';
import { KfiYourMortgagePage } from './kfi/pages/kfi-your-mortgage/kfi-your-mortgage.page';
import { KfiPage } from './kfi/pages/kfi/kfi.page';
import { KfiDataResolver } from './kfi/services/kfi-data-resolver.service';
import { KfiStore } from './kfi/services/kfi-store';
import { KfiService } from './kfi/services/kfi.service';
import { ApplicantOrderWarningDialogComponent } from './mortgage-application/components/applicant-order-warning-dialog/applicant-order-warning-dialog.component';
import { ApplicantCurrentPropertiesComponent } from './mortgage-application/components/applicant/applicant-current-properties/applicant-current-properties.component';
import { ApplicantDetailsComponent } from './mortgage-application/components/applicant/applicant-details/applicant-details.component';
import { ApplicantIncomeComponent } from './mortgage-application/components/applicant/applicant-income/applicant-income.component';
import { ApplicantLivedPlacesComponent } from './mortgage-application/components/applicant/applicant-lived-places/applicant-lived-places.component';
import { FormIncomeOutsideUkComponent } from './mortgage-application/components/applicant/form-income-outside-uk/form-income-outside-uk.component';
import { DeclarationContentComponent } from './mortgage-application/components/declaration/declaration-content/declaration-content.component';
import { MarketingDeclarationContentComponent } from './mortgage-application/components/declaration/marketing-declaration-content/marketing-declaration-content.component';
import { FormAddressComponent } from './mortgage-application/components/form-inputs/form-address/form-address.component';
import { FormApplicationProductSelectionComponent } from './mortgage-application/components/form-inputs/form-application-product-selection/form-application-product-selection.component';
import { FormCheckboxListComponent } from './mortgage-application/components/form-inputs/form-checkbox-list/form-checkbox-list.component';
import { FormCheckboxComponent } from './mortgage-application/components/form-inputs/form-checkbox/form-checkbox.component';
import { FormDateComponent } from './mortgage-application/components/form-inputs/form-date/form-date.component';
import { FormDeclarationRadioButtonComponent } from './mortgage-application/components/form-inputs/form-declaration-radio-button/form-declaration-radio-button.component';
import { FormListviewComponent } from './mortgage-application/components/form-inputs/form-listview/form-listview.component';
import { FormOptionListComponent } from './mortgage-application/components/form-inputs/form-option-list/form-option-list.component';
import { FormTermInputComponent } from './mortgage-application/components/form-inputs/form-term-input/form-term-input.component';
import { FormTextAreaComponent } from './mortgage-application/components/form-inputs/form-textarea/form-textarea.component';
import { HardCreditWarningDialogComponent } from './mortgage-application/components/hard-credit-warning-dialog/hard-credit-warning-dialog.component';
import { MortgageAppSectionNavigationComponent } from './mortgage-application/components/mortgage-app-section-navigation/mortgage-app-section-navigation-section-navigation.component';
import { AboutTheMortgageComponent } from './mortgage-application/components/mortgage/about-the-mortgage/about-the-mortgage.component';
import { AdditionalBorrowingsBtlComponent } from './mortgage-application/components/mortgage/additional-borrowings-btl/additional-borrowings-btl.component';
import { AdditionalBorrowingsResidentialComponent } from './mortgage-application/components/mortgage/additional-borrowings-residential/additional-borrowings-residential.component';
import { FormDepositSourceTypeComponent } from './mortgage-application/components/mortgage/form-deposit-source-type/form-deposit-source-type.component';
import { ProductRepaymentMethodsComponent } from './mortgage-application/components/mortgage/product-repayment-methods/product-repayment-methods.component';
import { SortCodeInputComponent } from './mortgage-application/components/mortgage/sort-code-input/sort-code-input.component';
import { ApplicantOutgoingComponent } from './mortgage-application/components/outgoings/applicant-outgoing/applicant-outgoing.component';
import { FormOutgoingsComponent } from './mortgage-application/components/outgoings/form-outgoings/form-outgoings.component';
import { YourOutgoingsAboutComponent } from './mortgage-application/components/outgoings/your-outgoings-about/your-outgoings-about.component';
import { YourOutgoingsDeclarationComponent } from './mortgage-application/components/outgoings/your-outgoings-declaration/your-outgoings-declaration.component';
import { ProgressStepperComponent } from './mortgage-application/components/progress-stepper/progress-stepper.component';
import { YourPropertyAdditionalInfoComponent } from './mortgage-application/components/property/your-property-additional-info/your-property-additional-info.component';
import { YourPropertyContactsComponent } from './mortgage-application/components/property/your-property-contacts/your-property-contacts.component';
import { YourPropertyDetailsComponent } from './mortgage-application/components/property/your-property-details/your-property-details.component';
import { YourPropertyLegalSupportComponent } from './mortgage-application/components/property/your-property-legal-support/your-property-legal-support.component';
import { SaveApplicationComponent } from './mortgage-application/components/save-application/save-application.component';
import { SaveFactFind2Component } from './mortgage-application/components/save-factfind2/save-factfind2.component';
import { SoftCreditWarningDialogComponent } from './mortgage-application/components/soft-credit-warning-dialog/soft-credit-warning-dialog.component';
import { ApplicantPage } from './mortgage-application/pages/applicant/applicant.page';
import { DeclarationPage } from './mortgage-application/pages/declaration/declaration.page';
import { MortgageApplicationPage } from './mortgage-application/pages/mortgage-application/mortgage-application.page';
import { YourMortgagePage } from './mortgage-application/pages/your-mortgage/your-mortgage.page';
import { YourOutgoingsPage } from './mortgage-application/pages/your-outgoings/your-outgoings.page';
import { YourPropertyPage } from './mortgage-application/pages/your-property/your-property.page';
import { MortgageApplicationDataResolver } from './mortgage-application/services/mortgage-application-data-resolver';
import { MortgageApplicationRouterService } from './mortgage-application/services/mortgage-application-router.service';
import { MortgageApplicationStore } from './mortgage-application/services/mortgage-application-store';
import { MortgageApplicationService } from './mortgage-application/services/mortgage-application.service';
import { TabNavigationService } from './mortgage-application/services/tab-navigation.service';
import { BaseSectionNavigationComponent } from './shared/components/base-section-navigation.component';
import { FeesComponent } from './shared/components/fees/fees.component';
import { FormApplicationTabComponent } from './shared/components/form-application-tab/form-application-tab.component';
import { FormInformationBoxComponent } from './shared/components/form-inputs/form-information-box/form-information-box.component';
import { FormNumericInputComponent } from './shared/components/form-inputs/form-numeric-input/form-numeric-input.component';
import { FormRadioButtonComponent } from './shared/components/form-inputs/form-radio-button/form-radio-button.component';
import { FormTextInputComponent } from './shared/components/form-inputs/form-text-input/form-text-input.component';
import { MortgageClubsComponent } from './shared/components/mortgage-clubs/mortgage-clubs.component';
import { PartAndPartControlComponent } from './shared/components/part-and-part-control/part-and-part-control.component';
import { ValidationErrorComponent } from './shared/components/validation-error/validation-error.component';
import { FormProductService } from './shared/services/form-product.service';
import { PartAndPartProductService } from './shared/services/part-and-part-product.service';
import { NotifyChangeDetectionService } from '../lib/services/notify-change-detection.service';

const COMPONENTS = [
  FormTextInputComponent,
  FormNumericInputComponent,
  FormRadioButtonComponent,
  FormOptionListComponent,
  FormCheckboxComponent,
  FormTextAreaComponent,
  FormDateComponent,
  FormAddressComponent,
  FormTermInputComponent,
  FormInformationBoxComponent,
  FormCheckboxListComponent,
  FormApplicationProductSelectionComponent,
  FormKfiProductSelectionComponent,

  ApplicantDetailsComponent,
  SaveApplicationComponent,
  SaveFactFind2Component,
  ValidationErrorComponent,
  FormApplicationTabComponent,
  ApplicantLivedPlacesComponent,
  ApplicantIncomeComponent,
  ApplicantCurrentPropertiesComponent,
  YourPropertyDetailsComponent,
  YourPropertyContactsComponent,
  YourPropertyLegalSupportComponent,
  YourPropertyAdditionalInfoComponent,
  DeclarationPage,
  FormListviewComponent,
  AboutTheMortgageComponent,
  AdditionalBorrowingsResidentialComponent,
  AdditionalBorrowingsBtlComponent,
  ProductRepaymentMethodsComponent,
  FormDepositSourceTypeComponent,
  SortCodeInputComponent,
  FeesComponent,
  FormIncomeOutsideUkComponent,
  YourOutgoingsAboutComponent,
  YourOutgoingsDeclarationComponent,
  DeclarationContentComponent,
  MarketingDeclarationContentComponent,
  FormDeclarationRadioButtonComponent,
  FormOutgoingsComponent,
  ApplicantOutgoingComponent,
  MortgageClubsComponent,
  ProgressStepperComponent,
  KfiProgressStepperComponent,
  HardCreditWarningDialogComponent,
  SoftCreditWarningDialogComponent,
  ApplicantOrderWarningDialogComponent,
  PartAndPartControlComponent,

  KfiAboutTheMortgageControlComponent,
  KfiApplicantControlComponent,
  DeleteKfiApplicantDialogComponent,
  SaveKfiComponent,
  BaseSectionNavigationComponent,
  MortgageAppSectionNavigationComponent,
  KfiSectionNavigationComponent
];
const PAGES = [
  ApplicantPage,
  YourMortgagePage,
  YourPropertyPage,
  YourOutgoingsPage,
  MortgageApplicationPage,

  KfiPage,
  KfiYourMortgagePage,
  KfiApplicantPage
];
const PROVIDERS = [
  MortgageApplicationService,
  MortgageApplicationDataResolver,
  MortgageApplicationRouterService,
  MortgageApplicationStore,
  FormProductService,
  TabNavigationService,
  PartAndPartProductService,

  NotifyChangeDetectionService,
  KfiStore,
  KfiService,
  KfiDataResolver
];

@NgModule({
  declarations: [COMPONENTS, PAGES],
  imports: [CommonModule, RomeLibraryModule, RomeKendoModule, FormsModule, RouterModule],
  providers: PROVIDERS,
  exports: [COMPONENTS, PAGES]
})
export class FormApplicationModule {}
